import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SizingIcon from '../../../../../../icons/SizingIcon';
import DesignEditorPrimaryControlButton from '../../../../../DesignEditor/components/DesignEditorControls/components/DesignEditorPrimaryControlButton';

const propTypes = {
  className: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

const CollageDesignerLayoutControlsButton = ({
  className,
  active,
  onClick,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorPrimaryControlButton
      className={classes}
      active={active}
      icon={<SizingIcon />}
      title="Layout"
      onClick={onClick}
    />
  );
};

CollageDesignerLayoutControlsButton.propTypes = propTypes;

export default CollageDesignerLayoutControlsButton;
